"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Talenzap APIs
 * API documentation for the backend services of Talenzap
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompetitionChipType = void 0;
/**
 *
 * @export
 * @enum {string}
 */
exports.CompetitionChipType = {
    VotesToFirst: 'VOTES_TO_FIRST',
    EndingInDays: 'ENDING_IN_DAYS',
    EndingInHours: 'ENDING_IN_HOURS',
    FirstPrize: 'FIRST_PRIZE',
    CompetitionHeatingUp: 'COMPETITION_HEATING_UP'
};
